"use client";

import GridLayout from "@/app/components/Layout/GridLayout";
import Heading from "@/app/components/Elements/Heading";
import Map from "@/app/components/Elements/Map";
import FadeIn from "@/app/components/Elements/FadeIn";

const page = () => {
  return (
    <main>
      <GridLayout>
        <section className="mt-16 md:col-span-12 md:mt-32">
          <FadeIn>
            <Heading title="Outline" subTitle="会社概要"></Heading>
          </FadeIn>

          <FadeIn>
            <dl className="mt-8 md:1mt-16 font-bold">
              <div className="grid grid-cols-3 gap-4 md:gap-8 border border-gray border-b-0">
                <dt className="p-4 h-full bg-secondary self-center">社名</dt>
                <dd className="p-4 col-span-2">有限会社サン鉄工</dd>
              </div>

              <div className="grid grid-cols-3 gap-4 md:gap-8 border border-gray border-b-0">
                <dt className="p-4 h-full bg-secondary self-center">所在地</dt>
                <dd className="p-4 col-span-2">
                  〒591-8023 大阪府堺市北区中百舌鳥町6丁目956番地2
                </dd>
              </div>

              <div className="grid grid-cols-3 gap-4 md:gap-8 border border-gray border-b-0">
                <dt className="p-4 h-full bg-secondary self-center">TEL</dt>
                <dd className="p-4 col-span-2">072-257-3565</dd>
              </div>

              <div className="grid grid-cols-3 gap-4 md:gap-8 border border-gray border-b-0">
                <dt className="p-4 h-full bg-secondary self-center">FAX</dt>
                <dd className="p-4 col-span-2">072-249-7620</dd>
              </div>

              <div className="grid grid-cols-3 gap-4 md:gap-8 border border-gray border-b-0">
                <dt className="p-4 h-full bg-secondary self-center">資本金</dt>
                <dd className="p-4 col-span-2">1000万円</dd>
              </div>

              <div className="grid grid-cols-3 gap-4 md:gap-8 border border-gray border-b-0">
                <dt className="p-4 h-full bg-secondary self-center">代表者</dt>
                <dd className="p-4 col-span-2">代表取締役　小林 隆一</dd>
              </div>

              <div className="grid grid-cols-3 gap-4 md:gap-8 border border-gray border-b-0">
                <dt className="p-4 h-full bg-secondary self-center">創業</dt>
                <dd className="p-4 col-span-2">昭和40年4月</dd>
              </div>

              <div className="grid grid-cols-3 gap-4 md:gap-8 border border-gray border-b-0">
                <dt className="p-4 h-full bg-secondary self-center">設立</dt>
                <dd className="p-4 col-span-2">平成2年3月1日</dd>
              </div>

              <div className="grid grid-cols-3 gap-4 md:gap-8 border border-gray border-b-0">
                <dt className="p-4 h-full bg-secondary grid items-center h-full">
                  取引金融機関
                </dt>
                <dd className="p-4 col-span-2">
                  紀陽銀行　泉ヶ丘支店
                  <br />
                  大阪信用金庫 もず支店
                </dd>
              </div>

              <div className="grid grid-cols-3 gap-4 md:gap-8 border border-gray">
                <dt className="p-4 h-full bg-secondary self-center">
                  従業員数
                </dt>
                <dd className="p-4 col-span-2">6人</dd>
              </div>
            </dl>
          </FadeIn>
        </section>
        <section className="mt-16 md:col-span-12 md:mt-32">
          <FadeIn>
            <Heading title="Access" subTitle="アクセス" />
          </FadeIn>

          <FadeIn>
            <div className="mt-8 md:mt-16 h-[400px] md:h-[860px] max-w-5xl">
              <Map />
            </div>
          </FadeIn>
        </section>
      </GridLayout>
    </main>
  );
};

export default page;
